import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import {
  GetDealsUsedByAudiencesDocument,
  type GetDealsUsedByAudiencesQuery,
} from '../../../graphql/query/deals/GetDealsUsedByAudiences.generated.tsx';

type AudienceUsedByDeal = GetDealsUsedByAudiencesQuery['audienceUsedBy']['deals'][number];

export type DealUsedByAudience = AudienceUsedByDeal & {
  deal_id: string | null;
  name: string | null;
  status: string | null;
};

const normalizeDealUsedByAudience = (deal: AudienceUsedByDeal): DealUsedByAudience => {
  const { obj } = deal;

  return {
    ...deal,
    deal_id: obj.deal_id ?? null,
    name: obj.name ?? null,
    status: obj.status ?? null,
  };
};

export const useDealsUsedByAudiences = (audienceIds: string[], overrideSkip?: boolean) => {
  const { error, loading, data } = useQuery(GetDealsUsedByAudiencesDocument, {
    skip: overrideSkip || audienceIds.length === 0,
    variables: {
      audience_ids: audienceIds,
    },
  });

  const deals = useMemo(
    () => (data?.audienceUsedBy?.deals ?? []).map(normalizeDealUsedByAudience),
    [data?.audienceUsedBy?.deals]
  );

  return {
    error,
    loading,
    deals,
  };
};
